export const exactSearchInitialState = {
  isModalOpen: false,
  username: '',
  socialAccount: {
    data: [],
    loading: false,
    error: undefined,
  },
};
